// Centralized feature flags for the ERP application
// Use environment variables if available; default values inline

export const featureFlags = {
  procurement: {
    // Supplier Price Lists UI is gated until backend tables are available
    priceLists: false,
  },
} as const;

export type FeatureFlags = typeof featureFlags;
